// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import {
	library
} from '@fortawesome/fontawesome-svg-core'
import {
	faBars,
	faAngleLeft,
	faAngleRight,
	faLink
} from '@fortawesome/free-solid-svg-icons'
import {
	FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import router from './router'
import axios from 'axios'
import apiConfig from '../config/api.config'
import VueJsonp from 'vue-jsonp'
library.add({
	faBars,
	faAngleLeft,
	faAngleRight,
	faLink
})

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueJsonp,5000)
Vue.prototype.$axios = axios
axios.defaults.baseURL = apiConfig.baseUrl

Vue.filter('priceFloat', function(value) {
	value = value.toString();
	var result = Number(value).toFixed(2);
	return result;
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js